import initialState from './initialState';
import {
  RESET_STATE,
  
  FETCH_LOGIN_DETAILS,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,

  SEND_OTP,
  OTP_NOT_SENT,
  RESEND_OTP,

  PASSWORD_RESET,
  PASSWORD_RESET_FAIL,
  
  SEND_OTP_LOGIN
} from '../actions/actionConstants'


export default function LoginReducer(state = initialState.login, action) {

  switch (action.type) {

    case FETCH_LOGIN_DETAILS:
      return Object.assign({}, state, { isLoading: true }, { hasError: null })

    case LOGIN_SUCCESS:
      return Object.assign({}, state, { isLoading: false }, { user: action.data })

    case LOGIN_FAILURE:
      return Object.assign({}, state, { isLoading: false }, { hasError: action.error})

    case SEND_OTP:
      return Object.assign({}, state, { hasError: null })
    
    case SEND_OTP_LOGIN:
      return Object.assign({}, state, { hasError: null })

    case RESEND_OTP:
      return Object.assign({}, state, { hasError: null })

    case OTP_NOT_SENT:
      return Object.assign({}, state, { isLoading: false }, { hasError: action.error})
      
    case PASSWORD_RESET:
      return Object.assign({}, state, { isLoading: true }, { hasError: null })
  
    case PASSWORD_RESET_FAIL:
      return Object.assign({}, state, { isLoading: false }, { hasError: action.error})

    case RESET_STATE:
      return Object.assign({}, state, { isLoading: false }, { hasError: null })

    default:
      return state;
  }
}




// WEBPACK FOOTER //
// ./src/reducers/LoginReducer.js